import { AlertTriangle } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface PendingSyncBadgeProps {
  className?: string;
}

export function PendingSyncBadge({ className }: PendingSyncBadgeProps): JSX.Element {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            className={`bg-amber-50 text-amber-700 border-amber-300 ${className ?? ''}`}
            data-testid="pending-sync-badge"
          >
            <AlertTriangle className="mr-1 h-3 w-3" />
            Pending Sync
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>Enrichment changes have not been synced to ScoutAround yet.</p>
          <p className="text-muted-foreground text-xs mt-1">
            Click &quot;Sync to ScoutAround&quot; to update the published listing.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
